import { render, staticRenderFns } from "./Tanks.vue?vue&type=template&id=7b664390&"
import script from "./Tanks.vue?vue&type=script&lang=js&"
export * from "./Tanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports